export enum ExportTypeEnum {
	TRADES = 'trades',
	USER_DATA = 'user_data',
}
